import React, { useEffect } from "react"
import { useSession } from "next-auth/react"
import { SSEMessage, SSEMessageType } from "../helpers/sse/sseManager"
import { deserialize } from "../helpers/database/setup/utils"
import { usePersonalAssistantMessageContext } from "../context/PersonalAssistantMessageContext"

export default function SseConnection({ children }) {
  // Use NextAuth session
  const { data: session, status } = useSession()

  // Import necessary contexts
  const { setPersonalAssistantMessage } = usePersonalAssistantMessageContext()

  // useEffect(() => {
  //   // Subscribe to new messages via SSE
  //   const connectToSSE = async () => {
  //     // Only connect to SSE if we have an active session
  //     if (status === "loading") {
  //       return
  //     }

  //     if (status !== "authenticated") {
  //       console.log("No active session, skipping SSE connection")
  //       return
  //     }

  //     const route = "/api/sse"

  //     // We have an active session, connect to SSE
  //     const eventSource = new EventSource(route)

  //     // eventSource.onopen = () => console.log("Connected to SSE")
  //     // eventSource.onerror = () => console.log("Error connecting to SSE")

  //     eventSource.onmessage = (event) => {
  //       // console.log("Received new message from SSE", event)
  //       const message = deserialize<SSEMessage>(event.data)

  //       const { type, data } = message

  //       if (type === SSEMessageType.CONNECTED) {
  //         console.log("Connected to SSE")
  //         return
  //       }

  //       if (type !== SSEMessageType.PING) {
  //         console.log("Received new message:", data)
  //       }

  //       if (type === SSEMessageType.NEW_PERSONAL_ASSISTANT_MESSAGE) {
  //         const newPersonalAssistantMessage = data
  //         console.log(
  //           "New personal assistant message:",
  //           newPersonalAssistantMessage
  //         )
  //         setPersonalAssistantMessage(newPersonalAssistantMessage)
  //       }
  //     }

  //     return () => eventSource.close()
  //   }

  //   connectToSSE()
  // }, [status, session?.user?.email, setPersonalAssistantMessage])

  return <>{children}</>
}
